import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Trustpilot, { Total } from '@lmt-rpb/Trustpilot/Trustpilot.vue';
import { getFluxApiUrl } from '@utils/utils';
import { determineClient, getClientString } from '@utils/environmentUtils';

import axios, { AxiosResponse } from 'axios';
import { ref } from 'vue';
import { TrustpilotReview } from '@/interfaces/common';
import { ObserveVisibility as vObserveVisibility } from 'vue-observe-visibility';

interface Props {
	baseURL: string,
	trustpilotUrl: string,
	minStars: string,
	limit: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TrustpilotContainer',
  props: {
    baseURL: {},
    trustpilotUrl: {},
    minStars: {},
    limit: {}
  },
  setup(__props: any) {

const props = __props;

const reviews = ref<TrustpilotReview[]>([]);

const total = ref<Total>({ reviews: 0, stars: 0 });

const showTrustpilot = ref(true);

const client = determineClient(props.baseURL);

const fluxRestApiUrl = ref(getFluxApiUrl());

const clientStringValue = getClientString();

const getReviews = (): void => {
	// eslint-disable-next-line no-undef
	axios({
		method: 'GET',
		url: fluxRestApiUrl.value + '/v1/trustpilot',
		headers: {
			'content-type': 'application/json'
		},
		params: {
			client: clientStringValue,
			'min-stars': props.minStars,
			limit: props.limit
		}
	})
		.then((response: AxiosResponse) => {
			if (response.data && Object.keys(response.data).length) {
				reviews.value = response.data.reviews;
				total.value.reviews = response.data.reviews_total;
				total.value.stars = response.data.stars;
				if (total.value.stars <= 2) {
					showTrustpilot.value = false;
				}
			} else {
				// eslint-disable-next-line no-console
				console.error('No trustpilot reviews were loaded.');
			}
		})
		.catch(function(error) {
			// eslint-disable-next-line no-console
			console.log(error);
		});
};

const visibilityChanged = (isVisible: boolean) => {
	if (isVisible) getReviews();
};

return (_ctx: any,_cache: any) => {
  return (showTrustpilot.value)
    ? _withDirectives((_openBlock(), _createBlock(Trustpilot, {
        key: 0,
        "flux-rest-api-url": fluxRestApiUrl.value,
        "base-u-r-l": _ctx.baseURL,
        "trustpilot-url": _ctx.trustpilotUrl,
        client: _unref(client),
        reviews: reviews.value,
        total: total.value
      }, null, 8 /* PROPS */, ["flux-rest-api-url", "base-u-r-l", "trustpilot-url", "client", "reviews", "total"])), [
        [_unref(vObserveVisibility), {
			callback: visibilityChanged,
			once: true,
			intersection: {
				root: null,
				rootMargin: '100px 0px 0px 0px'
			}
		}]
      ])
    : _createCommentVNode("v-if", true)
}
}

})